import React from 'react';

export default function Hero() {
    return (
<div className="tips-box">
                   {/* <h2>Eco-Friendly Tips</h2>
                     <ul>
                        <li>Reduce plastic use by carrying reusable bags and bottles.</li>
                        <li>Switch to energy-efficient LED bulbs to save electricity.</li>
                        <li>Recycle responsibly and separate waste appropriately.</li>
                        <li>Use eco-friendly cleaning products to reduce harmful chemicals.</li>
                        <li>Plant more trees and support local greenery initiatives.</li>
                    </ul> */}
        <h2>Get Started with Eco Lens</h2>
        <p> Dispose smarter. Use Eco Lens to quickly discover the right way to discard your items, supporting a more sustainable world.</p>
        <ul>Search by Name</ul>

<li>Type the item's name in the search bar and press Enter.</li>
<li>Get instant disposal instructions.</li>
<ul>Upload an Image </ul>

<li>Click the camera icon to take a photo, or the upload icon to select one.</li>
<li>We'll identify the item and tell you how to dispose of it.</li>
<ul>Results Include</ul>

<li>Clear disposal methods (recycle, compost, general waste, etc.) </li>
<li>Any specific instructions. </li>
            
                </div>
                );
}